import { useQueries, useSelectRows } from '@/src/tools/hooks/listPageHooks';
import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Button, ModalFooter, SizeFittingTable } from 'src/components/Antd';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import ModalHoc from 'src/constrains/ModalHOC';
import Query, { EnumQueryType } from 'src/constrains/Query1';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import {
  getCustomersInSalesChannel,
  getTagsInSalesChannel,
} from 'src/request/customer';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { generalSort } from 'src/tools/helper';
import { EnumTablePosition } from 'src/types/common/common';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { getI18nFromGeneral } from '@/src/tools/tools';

const convertQuery = (filter) => {
  const re: any = {};
  if (filter.customerTags) {
    if (filter.customerTags.length > 0) {
      re.customerTags = filter.customerTags.map((i) => {
        const { value } = i;
        return value;
      });
    }
  }

  //if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};
const filterList = (taggedList) => {
  return [
    {
      type: EnumFilterType.MultipleSelection,
      dropdownProps: { name: getI18nFromGeneral('general.hOCTitle.tags') },
      keyWord: 'customerTags',
      options: taggedList.map((item) => ({
        label: item.name,
        value: item.uuid,
      })),
      searchable: true,
    },
  ];
};

const Modal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { uuid }: any = useParams();
  const constants = { salesChannelUuid: uuid, firstRow: 0, countPerPage: 999 };
  const { selected, onCancel, onConfirm } = props;
  const currentSelected = (selected || []).map((i) => i.uuid);
  // const [selectedCustomers, setSelectedCustomers] =
  //   React.useState(currentSelected);
  const [allCustomers, setAllCustomers] = React.useState([]);
  const [tags, setTags] = React.useState([]);
  // const [loaded, setLoaded] = React.useState(false);

  const col = [
    {
      minWidth: 150,
      className: css.modalRow,
      title: getI18n('general.customerID'),
      key: 'uuid',
      default: true,
      sorter: (a, b) => {
        const name1 = a.uuid || '';
        const name2 = b.uuid || '';
        return generalSort(name1, name2);
      },
      childGenerate: (a, record, index) => {
        const name = get(record, 'uuid');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 150,
      sorter: (a, b) => {
        const name1 = a.fullName || '';
        const name2 = b.fullName || '';
        return generalSort(name1, name2);
      },
      title: getI18n('general.customer.fullName'),
      className: css.modalRow,
      key: 'fullName',
      default: true,
      childGenerate: (a, record, index) => {
        const name = get(record, 'fullName');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 150,
      title: getI18n('general.customer.mobileNumber'),
      className: css.modalRow,
      key: 'areaCode',
      default: true,
      childGenerate: (a, record, index) => {
        const areaCode = get(record, 'areaCode') || '';
        const number = get(record, 'mobile') || '';
        const display = areaCode + ' ' + number || '';
        return (
          <NoWrapContainer>
            <Tooltip title={display}>{display}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 150,
      title: getI18n('general.customer.email'),
      className: css.modalRow,
      key: 'email',
      default: true,
      childGenerate: (a, record, index) => {
        const name = get(record, 'email');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 150,
      title: getI18n('general.remarks'),
      className: css.modalRow,
      key: 'remarks',
      default: true,
      childGenerate: (a, record, index) => {
        const name = get(record, 'remarks');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
  ];

  React.useEffect(() => {
    getTagsInSalesChannel(uuid).then((res: any) => {
      setTags(res);
    });
    getCustomersInSalesChannel(constants).then((res) => {
      const { results } = res;
      setAllCustomers(results);
    });
  }, []);

  const { queryProps, search } = useQueries(filterList(tags), [], convertQuery);

  useAfterDidMountEffect(() => {
    const { searchText, customerTags } = search || {};
    const conditions = {
      searchTextList: searchText,
      customerTags,
      ...constants,
    };
    getCustomersInSalesChannel(conditions).then((res) => {
      const { results } = res;
      setAllCustomers(results);
    });
  }, [search]);

  const handleOnSearchChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ search: e, type: EnumQueryType.search });
    }
  };

  const handleOnFilterChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ filter: e, type: EnumQueryType.filter });
    }
  };

  const handleOnSearchClose = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ item: e, type: EnumQueryType.closeTag });
    }
  };

  const { rowSelection, selectedRowKeys } = useSelectRows(
    allCustomers,
    currentSelected,
  );
  // console.log('selectedRowKeys', selectedRowKeys);
  const handleOnConfirm = () => {
    const customers = selectedRowKeys.map((i) => {
      const customer = allCustomers.find((c) => c.uuid === i);
      return customer;
    });
    if (onConfirm) {
      onConfirm(customers);
    }
  };
  return (
    <React.Fragment>
      <div className={css.container}>
        <div className={css.queryContainer}>
          <Query
            onSearchChange={handleOnSearchChange}
            onFilterChange={handleOnFilterChange}
            onTagClose={handleOnSearchClose}
            filters={queryProps.filters || []}
            sortList={queryProps.sortList || []}
            data={queryProps.searchConditions || []}
          />
        </div>
        <SizeFittingTable
          className={css.modalTableBody}
          id='SalesChannelDiscountCustomerModalTable'
          dataSource={allCustomers}
          rowSelection={rowSelection}
          pagination={false}
          columns={col}
          rowKey={'uuid'}
          scroll={{ x: 'max-content', y: 392 }}
        />
      </div>{' '}
      <ModalFooter
        frontCountTip={`${(selectedRowKeys || []).length} ${getI18n(
          'general.itemsselected',
        )}`}
        okText={getI18n('general.confirm')}
        cancelText={getI18n('general.cancel')}
        // okClassName={css.okBtn}
        onOk={handleOnConfirm}
        onCancel={onCancel}
      />
    </React.Fragment>
  );
};

const CustomerTable = ModalHoc(
  (props) => {
    const i18n = useI18n();
    const getI18n = (str) => {
      return i18nGet(i18n, str);
    };
    const { value, onChange, id, tableId, modalOp, disableEdit } = props;
    const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
      modalOp || {};
    const [customers, setCustomers] = React.useState(value || []);
    const isNoData = (customers || []).length === 0;
    React.useEffect(() => {
      if (value !== customers) {
        setCustomers(value || []);
      }
    }, [value]);
    const handleOnChange = (att) => {
      if (onChange) {
        onChange(att);
      }
    };
    const handleOnDelete = (index) => {
      const _customers = [...customers];
      _customers.splice(index, 1);
      setCustomers(_customers);
      handleOnChange(_customers);
    };
    const handleOnDeleteAll = () => {
      setCustomers([]);
      handleOnChange([]);
    };
    const handleOnModalConfirm = (customers) => {
      setCustomers(customers);
      handleOnChange(customers);
      onModalCancel();
    };
    const handleOnEdit = () => {
      setModalContent(
        <Modal
          selected={customers}
          onCancel={onModalCancel}
          onConfirm={handleOnModalConfirm}
        />,
      );
      setShowModal(true);
      setModalTitle(
        getI18n('salesChannelDirectDiscount.eligibalCondition.selectCustomer'),
      );
    };
    return (
      <div className={css.customerTableContainer} id={id}>
        {!isNoData && (
          <SizeFittingTable
            id={tableId || 'SalesChannelCustomerTable' + id}
            dataSource={customers}
            pagination={false}
            columns={col(handleOnDelete, disableEdit, getI18n)}
            rowKey={'uuid'}
            scroll={{ x: 'max-content', y: 560 }}
          />
        )}

        <div
          className={css.btnsContainer}
          style={{ marginTop: isNoData ? 0 : 32 }}>
          <Button
            className={css.addBtn}
            type='primary'
            onClick={handleOnEdit}
            disabled={disableEdit}>
            {getI18n(
              'salesChannelDirectDiscount.eligibalCondition.selectCustomer',
            ) || 'Select Customer'}
          </Button>
          {!isNoData && (
            <Button
              className={css.deleteBtn}
              onClick={handleOnDeleteAll}
              disabled={disableEdit}>
              {getI18n('general.dragNDropColumns.delete_all')}
            </Button>
          )}
        </div>
      </div>
    );
  },
  { width: 900 },
);
const col = (onDelete, disableEdit, getI18n) => [
  {
    minWidth: 150,
    sorter: (a, b) => {
      const name1 = a.uuid || '';
      const name2 = b.uuid || '';
      return generalSort(name1, name2);
    },
    className: css.modalRow,
    title: getI18n('general.customerID'),
    key: 'uuid',
    default: true,
    childGenerate: (a, record, index) => {
      const name = get(record, 'uuid');
      return (
        <NoWrapContainer>
          <Tooltip title={name}>{name}</Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    minWidth: 150,
    sorter: (a, b) => {
      const name1 = a.fullName || '';
      const name2 = b.fullName || '';
      return generalSort(name1, name2);
    },
    title: getI18n('general.customer.fullName'),
    className: css.modalRow,
    key: 'fullName',
    default: true,
    childGenerate: (a, record, index) => {
      const name = get(record, 'fullName');
      return (
        <NoWrapContainer>
          <Tooltip title={name}>{name}</Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    minWidth: 150,
    title: getI18n('general.customer.mobileNumber'),
    className: css.modalRow,
    key: 'areaCode',
    default: true,
    childGenerate: (a, record, index) => {
      const areaCode = get(record, 'areaCode') || '';
      const number = get(record, 'mobile') || '';
      const display = areaCode + ' ' + number || '';
      return (
        <NoWrapContainer>
          <Tooltip title={display}>{display}</Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    minWidth: 150,
    title: getI18n('general.customer.email'),
    className: css.modalRow,
    key: 'email',
    default: true,
    childGenerate: (a, record, index) => {
      const name = get(record, 'email');
      return (
        <NoWrapContainer>
          <Tooltip title={name}>{name}</Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    minWidth: 150,
    title: getI18n('general.remarks'),
    className: css.modalRow,
    key: 'remarks',
    default: true,
    childGenerate: (a, record, index) => {
      const name = get(record, 'remarks');
      return (
        <NoWrapContainer>
          <Tooltip title={name}>{name}</Tooltip>
        </NoWrapContainer>
      );
    },
  },
  disableEdit
    ? {}
    : {
        titleGenerate: () =>
          getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
        position: EnumTablePosition.mid,
        key: 'Actions',
        default: true,
        childGenerate: (url, record, index) => {
          return (
            <Actions
              onDelete={() => {
                if (onDelete) {
                  onDelete(index);
                }
              }}
            />
          );
        },
        width: 104,
      },
];
export default CustomerTable;
